exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stock__header[data-v-060c8da4]{background-color:#e1dc00;padding:65px 20px 20px}.stock__header .backlink[data-v-060c8da4]{margin-bottom:5px}.stock__header .stock__header-title-container[data-v-060c8da4]{display:flex;align-items:flex-end}.stock__header img[data-v-060c8da4]{width:100px;margin-left:35px}.stock__header span[data-v-060c8da4]{color:#fff;font-family:ClanFFBlack;font-size:25px;margin-top:25px;text-transform:uppercase;flex:1;text-align:right}.stock__header .search__field[data-v-060c8da4]{background-color:transparent;border:1px solid #008bd0;font-family:ClanPro;font-size:14px;color:#008bd0;width:100%;outline:none;height:45px;line-height:45px;padding:0 20px;border-radius:24px;margin-top:20px;margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-060c8da4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Stock/StockHeader.vue
// module id = 665
// module chunks = 0